(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var container = document.querySelector('[id^="product-variants-"]');
    if (!container) return;

    var productId = container.id.replace('product-variants-','');
    var variants = [];
    try { 
      variants = JSON.parse(container.getAttribute('data-variants') || '[]'); 
    } catch (e) { 
      console.error('product-variants.json parse error', e); 
      variants = []; 
    }

    var canonicalInput = document.getElementById('ProductHiddenId-' + productId) || document.querySelector('input[name="id"], select[name="id"]');
    var hiddenInput = canonicalInput;

    var priceNode = document.querySelector('.product-price--original');
    var compareNode = document.querySelector('.product-price--compare');
    var inventoryNode = document.querySelector('.product-out-of-stock-count');

    window._currentSelectedVariantId = canonicalInput ? canonicalInput.value : null;

    function setCanonicalVariantId(id) {
  if (!id) return;
  
  // Update ALL inputs with name="id"
  document.querySelectorAll('input[name="id"]').forEach(function(input){
    input.value = id;
    input.setAttribute('data-id', id);
  });
  
  if (canonicalInput) {
    var evt = new Event('change', { bubbles: true });
    evt.programmatic = true;
    canonicalInput.dispatchEvent(evt);
  }
  window._currentSelectedVariantId = String(id);
}

    function updateUIForVariantId(variantId) {
      if (!variantId) return;
      var v = variants.find(function(x){ return String(x.id) == String(variantId); });
      if (!v) return;

      if (window.__productPriceUpdate) {
        try { 
          window.__productPriceUpdate(variantId); 
        } catch(e){ }
      } else {
        if (priceNode && v.price != null) priceNode.textContent = (Number(v.price)/100).toFixed(2);
        if (compareNode) {
          if (v.compare_at_price && Number(v.compare_at_price) > Number(v.price)) {
            compareNode.textContent = (Number(v.compare_at_price)/100).toFixed(2);
            compareNode.setAttribute('aria-hidden','false');
          } else {
            compareNode.textContent = '';
            compareNode.setAttribute('aria-hidden','true');
          }
        }
      }

      if (inventoryNode) {
        var qty = (typeof v.inventory_quantity != 'undefined') ? Number(v.inventory_quantity) : null;
        inventoryNode.textContent = (qty == null) ? '' : (qty <= 0 ? 'Out of stock' : 'Only ' + qty + ' left in stock!');
      }

      setCanonicalVariantId(v.id);
    }

    function findVariantByValues(values) {
      return variants.find(function (v) {
        var ok = true;
       if (values[0] && v.option1 != null && String(v.option1) != String(values[0])) ok = false;
if (values[1] && v.option2 != null && String(v.option2) != String(values[1])) ok = false;
if (values[2] && v.option3 != null && String(v.option3) != String(values[2])) ok = false;
        return ok;
      });
    }

    document.querySelectorAll('.size-option').forEach(function(label){
      label.addEventListener('click', function(e){
        e.preventDefault();
        var radioId = label.getAttribute('for');
        var radio = radioId ? document.getElementById(radioId) : null;
        if (radio) radio.checked = true;

        var containerEl = label.closest('.size-options');
        if (containerEl) containerEl.querySelectorAll('.size-option').forEach(function(l){ l.classList.remove('active'); });
        label.classList.add('active');

        var values = [];
        document.querySelectorAll('.product-option').forEach(function(g, idx){
          var checked = g.querySelector('input[type="radio"]:checked');
          if (checked) values[idx] = checked.value;
          else {
            var activeLbl = g.querySelector('.size-option.active');
            values[idx] = activeLbl ? (activeLbl.dataset.value || activeLbl.textContent.trim()) : null;
          }
        });

        var matched = findVariantByValues(values);
        if (matched) updateUIForVariantId(matched.id);
        else console.warn('No variant matched for', values);
      });
    });

    var initialId = container.getAttribute('data-initial-variant-id') || (canonicalInput ? canonicalInput.value : null);
    if (initialId) updateUIForVariantId(initialId);

    document.addEventListener('change', function(e){
      if (!e.target) return;
      if (e.target.name == 'id' && !e.programmatic) {
        updateUIForVariantId(e.target.value);
      }
    });

    document.addEventListener('submit', function(e){
      var form = e.target;
      if (!form) return;
      if (!(form instanceof HTMLFormElement)) return;
      var inputInForm = form.querySelector('input[name="id"], select[name="id"]');
      var selectedId = window._currentSelectedVariantId || (canonicalInput ? canonicalInput.value : null);
      if (selectedId) {
        if (!inputInForm) {
          inputInForm = document.createElement('input');
          inputInForm.type = 'hidden';
          inputInForm.name = 'id';
          form.appendChild(inputInForm);
        }
        inputInForm.value = selectedId;
        inputInForm.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }, true);

    document.addEventListener('click', function(e){
      var btn = e.target.closest('button, input[type="submit"], a');
      if (!btn) return;
      var isAdd = btn.id == 'AddToCart' || btn.closest('[data-add-to-cart]') || btn.classList.contains('add-to-cart') || btn.matches('[aria-label="Add to cart"], [data-action="add-to-cart"]');
      if (!isAdd) return;

      var form = btn.closest('form') || document.querySelector('form[action^="/cart/add"]');
      if (!form) return;
      var inputInForm = form.querySelector('input[name="id"], select[name="id"]');
      var selectedId = window._currentSelectedVariantId || (canonicalInput ? canonicalInput.value : null);
      if (!selectedId) return;
      if (!inputInForm) {
        inputInForm = document.createElement('input');
        inputInForm.type = 'hidden';
        inputInForm.name = 'id';
        form.appendChild(inputInForm);
      }
      inputInForm.value = selectedId;
      inputInForm.dispatchEvent(new Event('change', { bubbles: true }));
    }, true);
  });
})();
